import React, { useEffect, useState } from "react";
import { Calendar } from "react-calendar";
import PrimaryButton from "../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import "../interviewScheduler/InterviewSchedulerStyle.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getMentorCallAvailableSlots,
  bookMentorCallSlots,
  interviewSliceData,
} from "../../reducers/interviewSlice";
import moment from "moment/moment";
import PageLoader from "../../components/globalComponents/PageLoader/PageLoader";
import { useSearchParams } from "react-router-dom";
// import InterviewConfirmPopup from "../../components/popups/interviewConfirmPopup/InterviewConfirmPopup";
import ErrorToast from "../../components/Toast/ErrorToast";

const MentorCallScheduler = () => {
  const { interviewSlots, isFetching, isSuccess, bookSlotResponse, isError } =
    useSelector(interviewSliceData);
  // const [selectedDate, setSelectedDate] = useState(
  //   new Date(moment(new Date()).add(1, "day"))
  // );

  // new Date(moment("2023-01-09"))
  const [selectedDate, setSelectedDate] = useState(
    new Date(
      moment(interviewSlots?.program?.mentorShipcallMailSentOn)
        .add(1, "days")
        .format("YYYY-MM-DD")
    )
  );
  // const [selectedDate, setSelectedDate] = useState(new Date("26 December, 2022 00:00:00"));
  const [activeSlot, setActiveSlot] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  // const [GuidelineConfirmed, setGuidlinesConfirmed] = useState();
  // const [guidelinePopupOpen, setGuidelinePopupOpen] = useState(true);
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const proId = searchParams.get("programId") ?? "";
  // const email = searchParams.get("redirectUrl") ?? "";
  const applicantId = searchParams.get("redirectUrl") ?? "";

  //Toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");

  // useEffect(() => {
  //   const obj = {
  //     programId: proId,
  //     applicantId: applicantId,
  //     date: moment(new Date()).add(1, "day").format("YYYY-MM-DD 00:00:00"),
  //   };
  //   dispatch(getMentorCallAvailableSlots(obj));
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (selectedDate) {
      const obj = {
        programId: proId,
        applicantId: applicantId,
        date: moment(selectedDate).format("YYYY-MM-DD 00:00:00"),
      };
      dispatch(getMentorCallAvailableSlots(obj));
    }
    // eslint-disable-next-line
  }, [selectedDate]);

  useEffect(() => {
    if (isSuccess) {
      setConfirmed(true);
    }
  }, [isSuccess]);

  const handleClickConfirm = (time, id) => {
    const obj = {
      id: id,
      applicantId: applicantId,
      date: moment(selectedDate).format("YYYY-MM-DD 00:00:00"),
      time: time,
    };
    dispatch(bookMentorCallSlots(obj));
  };

  // const handleGuidelinesConfirmed = () => {
  //   if (GuidelineConfirmed) {
  //     setGuidelinePopupOpen(false);
  //   } else {
  //     setIsShowError(true);
  //     setErrMessage("Please read the guidelines first.");
  //   }
  // };

  useEffect(() => {
    if (isError) {
      setIsShowError(true);
      setErrMessage("Something went wrong!");
    }
  }, [isError]);

  // if (!interviewSlots?.program) {
  //   return (
  //     <div>
  //       <p>Something went wrong</p>
  //     </div>
  //   );
  // }

  // useEffect(() => {
  //   if (Object.keys(bookSlotResponse).length != 0) {
  //     setConfirmed(true);
  //     // setOfferAcceptanceStatus(props?.offerStatusObj["offerLetterStatus"]);
  //     // setNotInterestedReason(props?.offerStatusObj["notInterestedReason"]);
  //   }
  // }, [bookSlotResponse]);

  if (
    new Date(
      moment(interviewSlots?.program?.mentorShipcallMailSentOn).add(3, "days")
    ).getTime() < new Date().getTime()
  ) {
    return (
      <div>
        <div className="interviewSchedulerContainerOuter">
          <div className="dealineContainerOuter">
            <p className="deadlineHeading">Deadline Passed</p>
            <div className="confirmouter deadlineOuter">
              <div className="confirm-inner">
                <img src="/assets/icons/deadlinePassed.svg" alt="" />
                <p className="text">
                  The deadline to <b>schedule the Mentor Connect call</b> was
                  till{" "}
                </p>
                <div className="tags mt-10">
                  <div className="primaryTag">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.66667 0.729492C4.90829 0.729492 5.10417 0.925368 5.10417 1.16699V1.89616H8.89583V1.16699C8.89583 0.925368 9.09171 0.729492 9.33333 0.729492C9.57496 0.729492 9.77083 0.925368 9.77083 1.16699V1.89643C10.1089 1.8974 10.394 1.90176 10.635 1.92145C10.9539 1.94751 11.234 2.00255 11.4931 2.13458C11.9047 2.3443 12.2394 2.67895 12.4491 3.09055C12.5811 3.34968 12.6362 3.62976 12.6622 3.94864C12.6875 4.25833 12.6875 4.64077 12.6875 5.11492V10.0524C12.6875 10.5265 12.6875 10.909 12.6622 11.2187C12.6362 11.5376 12.5811 11.8176 12.4491 12.0768C12.2394 12.4884 11.9047 12.823 11.4931 13.0327C11.234 13.1648 10.9539 13.2198 10.635 13.2459C10.3253 13.2712 9.94289 13.2712 9.46874 13.2712H4.53126C4.05711 13.2712 3.67467 13.2712 3.36498 13.2459C3.04611 13.2198 2.76602 13.1648 2.5069 13.0327C2.09529 12.823 1.76065 12.4884 1.55092 12.0768C1.41889 11.8176 1.36385 11.5376 1.3378 11.2187C1.31249 10.909 1.3125 10.5265 1.3125 10.0524V5.11493C1.3125 4.64077 1.31249 4.25833 1.3378 3.94864C1.36385 3.62976 1.41889 3.34968 1.55092 3.09055C1.76065 2.67895 2.09529 2.3443 2.5069 2.13458C2.76602 2.00255 3.04611 1.94751 3.36498 1.92145C3.606 1.90176 3.89108 1.8974 4.22917 1.89643V1.16699C4.22917 0.925368 4.42504 0.729492 4.66667 0.729492ZM4.22917 2.77147C3.89697 2.77247 3.64388 2.77658 3.43623 2.79355C3.17147 2.81518 3.01936 2.85551 2.90414 2.91421C2.65717 3.04005 2.45639 3.24083 2.33055 3.4878C2.27185 3.60301 2.23152 3.75513 2.20989 4.01989C2.18784 4.28976 2.1875 4.63639 2.1875 5.13366V5.39616H11.8125V5.13366C11.8125 4.63639 11.8122 4.28976 11.7901 4.01989C11.7685 3.75513 11.7282 3.60301 11.6694 3.4878C11.5436 3.24083 11.3428 3.04005 11.0959 2.91421C10.9806 2.85551 10.8285 2.81518 10.5638 2.79355C10.3561 2.77658 10.103 2.77247 9.77083 2.77147V3.50033C9.77083 3.74195 9.57496 3.93783 9.33333 3.93783C9.09171 3.93783 8.89583 3.74195 8.89583 3.50033V2.77116H5.10417V3.50033C5.10417 3.74195 4.90829 3.93783 4.66667 3.93783C4.42504 3.93783 4.22917 3.74195 4.22917 3.50033V2.77147ZM11.8125 6.27116H2.1875V10.0337C2.1875 10.5309 2.18784 10.8776 2.20989 11.1474C2.23152 11.4122 2.27185 11.5643 2.33055 11.6795C2.45639 11.9265 2.65718 12.1273 2.90414 12.2531C3.01936 12.3118 3.17147 12.3521 3.43623 12.3738C3.7061 12.3958 4.05274 12.3962 4.55 12.3962H9.45C9.94726 12.3962 10.2939 12.3958 10.5638 12.3738C10.8285 12.3521 10.9806 12.3118 11.0959 12.2531C11.3428 12.1273 11.5436 11.9265 11.6694 11.6795C11.7282 11.5643 11.7685 11.4122 11.7901 11.1474C11.8122 10.8776 11.8125 10.5309 11.8125 10.0337V6.27116Z"
                        fill="#006CD4"
                      />
                    </svg>

                    {moment(interviewSlots?.program?.mentorShipcallMailSentOn)
                      .add(3, "days")
                      .format("ddd, MMMM, DD, YYYY")}
                  </div>
                  <div className="primaryTag">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.99996 1.60449C4.01992 1.60449 1.60413 4.02029 1.60413 7.00033C1.60413 9.98036 4.01992 12.3962 6.99996 12.3962C9.98 12.3962 12.3958 9.98036 12.3958 7.00033C12.3958 4.02029 9.98 1.60449 6.99996 1.60449ZM0.729126 7.00033C0.729126 3.53704 3.53667 0.729492 6.99996 0.729492C10.4632 0.729492 13.2708 3.53704 13.2708 7.00033C13.2708 10.4636 10.4632 13.2712 6.99996 13.2712C3.53667 13.2712 0.729126 10.4636 0.729126 7.00033ZM6.99996 3.06283C7.24158 3.06283 7.43746 3.2587 7.43746 3.50033V6.72994L9.52895 7.77568C9.74506 7.88374 9.83266 8.14653 9.7246 8.36265C9.61655 8.57876 9.35375 8.66636 9.13764 8.5583L6.8043 7.39164C6.65609 7.31753 6.56246 7.16604 6.56246 7.00033V3.50033C6.56246 3.2587 6.75833 3.06283 6.99996 3.06283Z"
                        fill="#006CD4"
                      />
                    </svg>
                    11:59 pm
                  </div>
                </div>
                <p className="text mt-15">
                  Thank you for your interest in{" "}
                  <b>
                    {" "}
                    MasterCamp in{" "}
                    {
                      interviewSlots?.program?.ProgramDetail?.Program
                        ?.programName
                    }
                  </b>
                </p>
                <p className="text mt-30">
                  <b>
                    Unfortunately, the deadline to schedule an interview has now
                    passed.
                  </b>
                </p>
                <p className="text mt-20">
                  We appreciate your interest and encourage you to keep an eye
                  on our <b>admissions page</b> for the next cohort.
                </p>
              </div>
            </div>
            <div className="footer">
              <p>
                Please reach out to your academic advisor in case of any query.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    const textDescription = () => {
      var spaceName =
        interviewSlots?.program?.ProgramDetail?.Program?.programName ===
        "User Experience Design"
          ? "Design"
          : interviewSlots?.program?.ProgramDetail?.Program?.programName ===
            "Applied Finance"
          ? "Finance"
          : interviewSlots?.program?.ProgramDetail?.Program?.programName ===
            "Human Resource Management"
          ? "HR"
          : interviewSlots?.program?.ProgramDetail?.Program?.programName ===
            "Product Management Bootcamp"
          ? "Product"
          : interviewSlots?.program?.ProgramDetail?.Program?.programName;

      return (
        <p className="congratsText">
          This is a 30-min Mentor-Connect Call to help you answer your queries
          regarding the {spaceName} space and how the programme can help you
          further your career. Consider this 30 min call as a safe space where
          you can discuss questions about your career, life, and the {spaceName}{" "}
          space in general.
        </p>
      );
    };

    return (
      <>
        {isFetching && <PageLoader />}
        <ErrorToast
          show={isShowError}
          setShow={() => setIsShowError(false)}
          message={errMessage}
        />

        <div className="interviewSchedulerContainerOuter">
          {!confirmed && (
            <div className="interviewSchedulerContainerOuter">
              <div className="interviewSchedulerHeader">
                <img src="../assets/icons/muLogoWhite.svg" alt="" />
                <p className="heading">
                  MasterCamp in{" "}
                  {interviewSlots?.program?.ProgramDetail?.Program?.programName}
                </p>
              </div>
              <div className="interviewSchedulerNew">
                <div className="interviewSchedulerNewLeftContainer">
                  <div className="newCongratsBox">
                    <div className="congratBoxContent">
                      <p className="name">
                        {interviewSlots?.program?.firstName}{" "}
                        {interviewSlots?.program?.lastName} !
                      </p>
                      <p className="congratsText">
                        <b>Congratulations</b> on the acceptance of your
                        candidature in the{" "}
                        <b>
                          {interviewSlots?.program?.ProgramDetail?.Program
                            ?.programName === "User Experience Design"
                            ? "MasterCamp in User Experience Design"
                            : interviewSlots?.program?.ProgramDetail?.Program
                                ?.programName === "Applied Finance"
                            ? "MasterCamp in Applied Finance"
                            : interviewSlots?.program?.ProgramDetail?.Program
                                ?.programName === "Human Resource Management"
                            ? "MasterCamp in Human Resource Management"
                            : interviewSlots?.program?.ProgramDetail?.Program
                                ?.programName === "Product Management Bootcamp"
                            ? "Product Management Bootcamp"
                            : interviewSlots?.program?.ProgramDetail?.Program
                                ?.programName}
                        </b>
                        .
                      </p>
                      <p className="congratsText">
                        Connect with a Mentor and get all your questions
                        answered.
                        {/* Here’s a chance to get your questions regarding the
                        programme answered. <b>Connect 1:1 with a Mentor</b> and
                        discuss how you can further your career in the{" "}
                        <b>
                          {interviewSlots?.program?.ProgramDetail?.Program
                            ?.programName === "User Experience Design"
                            ? "Design career"
                            : interviewSlots?.program?.ProgramDetail?.Program
                                ?.programName}
                        </b>{" "}
                        space. */}
                      </p>
                    </div>
                    <img
                      src="https://cdn.mastersunion.org/assets/imgV2/newInterviewSchedulerImage.png"
                      alt=""
                      className="congratsImageNew"
                    />
                  </div>
                  <div className="interviewDetailsBox">
                    <img
                      src="https://mastersunion.s3.ap-south-1.amazonaws.com/assets/imgV2/interviewDetailImg.png"
                      alt=""
                    />
                    <div className="interviewDetailsContent">
                      <div className="interviewDetails">
                        <p>Schedule your Call</p>
                        <div className="successTag">30 min</div>
                      </div>
                      {textDescription()}

                      {/* <div className="warningBox">
                        <p>
                          <strong>Note:</strong> Due to high volume of
                          applications, please ensure that you book your
                          interview slot latest by{" "}
                          <b>
                            {moment(interviewSlots?.program?.mentorShipcallMailSentOn)
                              .add(3, "days")
                              .format("DD MMMM, YYYY")}{" "}
                            11:59 PM
                          </b>
                          , post which we would be unable to schedule your
                          interview with the Admissions Panel.
                        </p>
                      </div> */}
                    </div>
                  </div>
                  <div className="guidelinesList">
                    <div className="interviewDetails">
                      <p>Call Guidelines :</p>
                    </div>
                    <div className="guideline">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663ZM11.5201 6.18656C11.7154 5.9913 11.7154 5.67472 11.5201 5.47945C11.3249 5.28419 11.0083 5.28419 10.813 5.47945L7.16659 9.1259L5.52014 7.47945C5.32488 7.28419 5.00829 7.28419 4.81303 7.47945C4.61777 7.67472 4.61777 7.9913 4.81303 8.18656L6.81303 10.1866C7.00829 10.3818 7.32488 10.3818 7.52014 10.1866L11.5201 6.18656Z"
                          fill="black"
                        />
                      </svg>{" "}
                      <p>
                        Ensure your device is connected with a{" "}
                        <b>stable internet connection</b> with a functional{" "}
                        <b>microphone</b> & <b>camera</b>.
                      </p>
                    </div>
                    <div className="guideline">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663ZM11.5201 6.18656C11.7154 5.9913 11.7154 5.67472 11.5201 5.47945C11.3249 5.28419 11.0083 5.28419 10.813 5.47945L7.16659 9.1259L5.52014 7.47945C5.32488 7.28419 5.00829 7.28419 4.81303 7.47945C4.61777 7.67472 4.61777 7.9913 4.81303 8.18656L6.81303 10.1866C7.00829 10.3818 7.32488 10.3818 7.52014 10.1866L11.5201 6.18656Z"
                          fill="black"
                        />
                      </svg>{" "}
                      <p>
                        Ensure you join the call <b>5 minutes prior</b> to the
                        scheduled start time.
                      </p>
                    </div>
                    <div className="guideline">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663ZM11.5201 6.18656C11.7154 5.9913 11.7154 5.67472 11.5201 5.47945C11.3249 5.28419 11.0083 5.28419 10.813 5.47945L7.16659 9.1259L5.52014 7.47945C5.32488 7.28419 5.00829 7.28419 4.81303 7.47945C4.61777 7.67472 4.61777 7.9913 4.81303 8.18656L6.81303 10.1866C7.00829 10.3818 7.32488 10.3818 7.52014 10.1866L11.5201 6.18656Z"
                          fill="black"
                        />
                      </svg>{" "}
                      <p>
                        Feel free to reach out to your academic counsellor in
                        case you’re facing any <b>trouble joining the call.</b>
                      </p>
                    </div>
                    <div className="guideline">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663ZM11.5201 6.18656C11.7154 5.9913 11.7154 5.67472 11.5201 5.47945C11.3249 5.28419 11.0083 5.28419 10.813 5.47945L7.16659 9.1259L5.52014 7.47945C5.32488 7.28419 5.00829 7.28419 4.81303 7.47945C4.61777 7.67472 4.61777 7.9913 4.81303 8.18656L6.81303 10.1866C7.00829 10.3818 7.32488 10.3818 7.52014 10.1866L11.5201 6.18656Z"
                          fill="black"
                        />
                      </svg>
                      <p style={{width:'95%'}}>
                        In case you have any queries regarding the{" "}
                        <b>programme</b> or the <b>admissions process</b>,
                        please reach out directly to your academic counsellor or
                        write to us at mastercampadmissions@mastersunion.org.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="interviewSchedulerNewRightContainer">
                  <div className="interviewSchedulerColumeTwo">
                    <Calendar
                      minDate={new Date(new Date())}
                      maxDate={
                        new Date(
                          moment(
                            interviewSlots?.program?.mentorShipcallMailSentOn
                          )
                            .add(15, "days")
                            .format("YYYY-MM-DD")
                        )
                      }
                      onChange={setSelectedDate}
                      value={
                        selectedDate
                          ? selectedDate
                          : new Date(
                              moment(
                                interviewSlots?.program
                                  ?.mentorShipcallMailSentOn
                              )
                                .add(1, "days")
                                .format("YYYY-MM-DD")
                            )
                      }
                    />
                  </div>
                  <div className="interviewSchedulerColumeThree">
                    <p className="month">
                      {selectedDate
                        ? moment(selectedDate).format("MMMM YYYY")
                        : moment(new Date()).format("MMMM YYYY")}
                    </p>
                    <div className="slotsOuter">
                      {interviewSlots?.Data?.length > 0
                        ? interviewSlots?.Data?.map((slot, index) => (
                            <div
                              key={index}
                              className={`slots ${
                                activeSlot === slot.time && "active"
                              }`}
                              onClick={() =>
                                activeSlot === slot.time
                                  ? setActiveSlot("")
                                  : setActiveSlot(slot.time)
                              }
                            >
                              <div className="slot">
                                {moment(slot.time, ["HH:mm"]).format("hh:mm A")}
                              </div>
                              <PrimaryButton
                                classname={"primaryBtn"}
                                children={"Confirm"}
                                onClick={() =>
                                  handleClickConfirm(slot.time, slot.id)
                                }
                              />
                            </div>
                          ))
                        : "No slot available"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {confirmed && (
            <div
              className="confirmouter"
              // style={confirmed ? null : { display: "none" }}
            >
              <div className="confirm-inner">
                <img src="/assets/img/checkconfirm.gif" alt="" />
                <h3 className="heading-3 mt-10">Confirmed</h3>
                <p className="text-24 ns-bold mt-20">
                  Your Mentor Connect call has been scheduled!
                </p>
                <div className="innerbox mt-20">
                  <p className="text-2 mt-20">
                    {" "}
                    <b>
                      {bookSlotResponse?.Applicant?.firstName +
                        " " +
                        bookSlotResponse?.Applicant?.lastName}{" "}
                    </b>
                    your Mentor Connect call has been scheduled with{" "}
                    <b>
                      {bookSlotResponse?.Admin?.firstName +
                        " " +
                        bookSlotResponse?.Admin?.lastName}
                    </b>
                    .{" "}
                  </p>
                  <div className="confirmInnerBox flexbox mt-30">
                    <div className="gtag">
                      {" "}
                      <img
                        src="/assets/icons/calendar-check-01.svg"
                        alt=""
                      />{" "}
                      {moment(selectedDate).format("DD MMMM, YYYY")}
                    </div>
                    <div className="gtag">
                      {" "}
                      <img src="/assets/icons/clock.svg" alt="" />{" "}
                      {bookSlotResponse?.time}
                    </div>
                  </div>
                  <p className="text-2 mt-10">
                    A calendar invitation with the{" "}
                    <label
                      onClick={() => window.open(bookSlotResponse?.meetingLink)}
                      className="link"
                    >
                      meeting link
                    </label>{" "}
                    has been sent to your email address.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
};

export default MentorCallScheduler;
